import './TokenBase-a805f182.css';

var classes = {"TokenBase":"prc-Token-TokenBase-PfQzJ"};

export { classes as default };
